import React, { Component } from 'react';
import {Dummy} from '../';
import styles from './style.css';
var classNames = require('classnames');

export default class Tank extends Dummy {

    paintCanvas(cvs, disabled, level, low) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');

            ctx.clearRect(0,0,canvas.width,canvas.height);
        if (disabled){
            ctx.strokeStyle = "black";
            ctx.strokeRect(24,21,131,378);
            ctx.fillStyle = "grey";
            ctx.fillRect(24,21,131,378);
        }
        else {
            ctx.fillStyle = "white";
            ctx.fillRect(24,21,133,378);

            switch (level) {
                case 0:
                case 14:
                    ctx.fillStyle = "red";
                    break;
                case 12:
                    ctx.fillStyle = "green";
                    break;
                case 8:
                    ctx.fillStyle = "orange";
                    break;
                default:
                    ctx.fillStyle = "gray";
                    break;
            }

            var h = (level / 2 + 1) * canvas.height / 9;
            ctx.fillRect(24, 400 - h, canvas.width, h);
        }

        ctx.beginPath();
        ctx.moveTo(41,31);
        ctx.lineTo(41,12);
        ctx.stroke(); 
    ctx.beginPath();
    ctx.arc(31,12,10,Math.PI*1,Math.PI*0,false);     
        ctx.stroke();
    ctx.beginPath();
        ctx.moveTo(21,12);
        ctx.lineTo(21,60);
        ctx.stroke(); 
    ctx.beginPath();
    ctx.arc(11,60,10,Math.PI*1,Math.PI*0,true);
    ctx.stroke(); 
    ctx.beginPath();
        ctx.moveTo(1,60);
        ctx.lineTo(1,46);
        ctx.stroke(); 
    ctx.closePath();
    
    ctx.fillStyle = "black";
    ctx.font = "italic bold 12px Arial";
        ctx.fillText("БА",75,14);
        }
    };

    render() {
        let avarClass = {};
        avarClass[styles.avar] =(this.getCleanValue(this.props.ps[1])==0);
        return (
            <div id={this.props.div_id} className={classNames(this.props.className,styles.wrap)}>
                <canvas className='cvs' id={this.props.canvas_id} width="157" height="400"/>
                <i className={classNames("fa fa-exclamation-circle", styles.default, avarClass)}/>
            </div>
        );
    }
}

Tank.propTypes = {
     div_id: React.PropTypes.string,
     canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Tank/index.js